<template>
  <div class="page-content">
    <p class="newMine_pageTitle newMine_pageTitleb m-b10">
      <span class="newMine_pageTitles">专业计划</span>
    </p>

    <div class="newMine_table">
      <el-table :data="pageData.records" border :cell-style="tableStyle.cellStyle"
        :span-method="courseCategorySpanMethod" :header-cell-style="tableStyle.headerCellStyle">
        <el-table-column label="序号" type="index" width="50">
        </el-table-column>
        <!-- <el-table-column prop="courseCategory" label="课程类别" show-overflow-tooltip>
          <template #default="{ row }">
            {{ row.courseCategory | f('courseCategory') }}
          </template>
        </el-table-column> -->
        <el-table-column prop="date" label="课程名称" show-overflow-tooltip>
          <template #default="{ row }">
            {{ row.courseCode + '-' + row.courseName }}
          </template>
        </el-table-column>
        <el-table-column prop="date" label="课程类型" show-overflow-tooltip>
          <template #default="{ row }">
            {{ row.courseType | f('courseType') }}
          </template>
        </el-table-column>
        <el-table-column prop="studyProgress" label="参考教材" show-overflow-tooltip>
          <template #default="{ row }">
            <div v-if="row.textbookName">{{ row.textbookName }} {{ row.author }} {{ row.version }} {{ row.publisher }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="zycs" label="考试类型">
          <template #default="{ row }">
            {{ row.examType | f('examType') }}
          </template>
        </el-table-column>
        <el-table-column prop="homeworkScore" label="学分" show-overflow-tooltip>
          <template #default="{ row }">
            {{ row.score }}
          </template>
        </el-table-column>
        <el-table-column prop="homeworkFinalScore" label="成绩">
          <template #default="{ row }">
            {{ row.studentScore }}
          </template>
        </el-table-column>
        <el-table-column label="学习状态" width="100">
          <template #default="{ row }">
            <p v-if="row.examType == '2'">
              <span v-if="row.isOpen == '1'" class="status-tag opened">已开通</span>
              <span v-else class="status-tag closed">未开通</span>
            </p>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="自由学习" width="120">
          <template #default="{ row }">
            <template v-if="row.isOpen == '1' && row.examType == '2'">
              <el-button type="primary" size="mini" round class="free-study-btn" @click="goFreeStudy(row)">自由学习</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pageData.current" :page-sizes="[5, 10, 20, 50]" :page-size="pageData.size"
      layout="total, sizes, prev, pager, next, jumper" :total="pageData.total">
    </el-pagination> -->

    </div>



    <el-dialog :visible.sync="tipDialogVisible" width="400px" :show-close="false" center custom-class="tip-dialog">
      <div class="tip-dialog-content">
        <div class="tip-icon">
          <span>!</span>
        </div>
        <p class="tip-title">提示</p>
        <p class="tip-desc">还未开通学习功能，请与自己的教学点联系。</p>
        <el-button type="primary" round @click="tipDialogVisible = false">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  components: {
  },
  name: "SpecialtyPlan",
  data() {
    return {
      tableStyle: {
        cellStyle: { textAlign: 'center' },
        headerCellStyle: {
          textAlign: 'center',
          background: '#f5f7fa',
          color: '#303133',
        },
      },
      loading: false,
      pageData: {
        current: 1,
        size: 5,
        total: 0,
        records: [],
      },
      examConfigId: '',
      examConfigList: [],
      tipDialogVisible: false,
    };
  },
  computed: {
    ...mapState([])
  },
  async created() {
    this.getData();
  },
  methods: {
    courseCategorySpanMethod({ row, column, rowIndex }) {
      if (column.property === 'courseCategory') {
        // const sameRows = this.pageData.records.filter(item => item.courseCategory === row.courseCategory);
        // const firstIndex = this.pageData.records.findIndex(item => item.courseCategory === row.courseCategory);
        // if (rowIndex === firstIndex) {
        //   return {
        //     rowspan: sameRows.length,
        //     colspan: 1
        //   };
        // }
        if (this.pageData.records[rowIndex].courseCategory === this.pageData.records[rowIndex - 1]?.courseCategory) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else {
          let count = 1;
          for (let i = rowIndex + 1; i < this.pageData.records.length; i++) {
            if (this.pageData.records[i].courseCategory === this.pageData.records[rowIndex].courseCategory) {
              count++;
            } else {
              break;
            }
          }
          return {
            rowspan: count,
            colspan: 1
          };
        }
      }
    },
    getData() {
      this.$http.get('/student/pc/specialtyPut', { current: this.pageData.current, size: this.pageData.size }).then(res => {
        this.pageData.records = res.sort((a, b) => a.examType - b.examType).map(item => ({
          ...item,
        }));
      })
    },
    handleSizeChange(val) {
      this.pageData.size = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageData.current = val;
      this.getData();
    },
    showTipDialog() {
      this.tipDialogVisible = true;
    },
    goFreeStudy(row) {
      this.$router.push({
        path: '/main/courseDetail',
        query: {
          courseId: row.courseId,
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/variable.scss";
.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.newMine_form {
  padding: 0 30px;

}

.newMine_table {
  min-height: 430px;
  padding: 0 30px;
}

.status-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  &.opened { background: #E8F2FA; color: $primary; }
  &.closed { background: #fef0f0; color: #f56c6c; }
}

.free-study-btn {
  &.disabled { background-color: #ccc; border-color: #ccc; cursor: not-allowed; color: #fff; }
}


.tip-dialog-content {
  text-align: center;
  .tip-icon {
    width: 48px; height: 48px; border-radius: 50%; background: #fef0f0;
    margin: 0 auto 16px; display: flex; align-items: center; justify-content: center;
    span { color: #f56c6c; font-size: 24px; font-weight: bold; }
  }
  .tip-title { font-size: 16px; font-weight: bold; margin-bottom: 12px; color: #333; }
  .tip-desc { font-size: 14px; color: #666; margin-bottom: 24px; }
}
</style>
